import React from "react";
import { useNavigate } from "react-router-dom";

export const DebugButton: React.FC = () => {
  const navigate = useNavigate();

  const handleDebugClick = () => {
    navigate('/debug');
  };

  return (
    <button
      onClick={handleDebugClick}
      className="w-full px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors flex items-center justify-center gap-2"
    >
      <span role="img" aria-label="bug">
        🐞
      </span>
      Debug Panel
    </button>
  );
};